module.exports = __webpack_public_path__ + "media/Granddaughter.1a4f7655.mp3";